/* eslint-disable react/function-component-definition */
import { GridItem, gridConfig } from '@tvg/fuse-design/responsive-grid';
import React from 'react';
import styled from 'styled-components';

export interface RecsGridItemProps {
  lastOfType?: boolean;
}

const StyledGridItem = styled(GridItem)`
  display: grid;
  grid-column: auto / span 6;
  width: 100%;

  &.grid-item--hidden {
    display: none;
  }

  @media screen and (min-width: ${gridConfig.m.minWidth}) {
    & {
      grid-column: auto / span 4;
    }
  }

  @media screen and (max-width: ${gridConfig.s.maxWidth}) {
    &.grid-item--recs-container-last {
      display: none;
    }
  }
`;

export const RecsGridItem: React.FC<RecsGridItemProps> = ({ lastOfType: lastRec }) => (
  <StyledGridItem
    data-testid="gallery-recs-container"
    className={`grid-item grid-item--recs-container grid-item--hidden ${
      lastRec ? 'grid-item--recs-container-last' : ''
    }`}
  />
);
